import { render, staticRenderFns } from "./BuildingReport.vue?vue&type=template&id=ca3bfece&"
import script from "./BuildingReport.vue?vue&type=script&lang=js&"
export * from "./BuildingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports